import { isAndroid } from '../platform/NativeBridge';
import { NativeVoiceProvider } from './providers/NativeVoiceProvider';
import { WebVoiceProvider } from './providers/WebVoiceProvider';

/**
 * The one entry point used by every Athena surface. UI keeps its own layout,
 * while the voice lifecycle is selected strictly by runtime platform.
 */
export function createAthenaVoice(options = {}) {
  return isAndroid ? new NativeVoiceProvider(options) : new WebVoiceProvider(options);
}

export { NativeVoiceProvider, WebVoiceProvider };
